import React from 'react';
import AppService from '../service/AppService';
import Counter from './Counter';
import PropTypes from 'prop-types';
import AppConfig from '../domain/AppConfig';
import get from 'lodash/get';
import { createRefetchContainer, graphql } from 'react-relay';

const appConfig: AppConfig = AppService.appConfig();

class CartBadge extends React.Component {
  static propTypes = {
    viewer: PropTypes.shape({
      id: PropTypes.string,
      cartBadge: PropTypes.shape({
        totalPurchaseNumber: PropTypes.number,
      }),
    })
  };

  render() {
    let url = '#';
    let totalPurchaseNumber = undefined;

    let cartBadge = get(this.props, 'viewer.cartBadge');
    if (cartBadge) {
      url = `https://order${appConfig.baseComDomain}/cart`;
      totalPurchaseNumber = cartBadge.totalPurchaseNumber;
    }

    return (
      <a className="cartPict" href={url} target="_self">
        <div className="util-icon cart" />
        {totalPurchaseNumber > 0 && (
          <Counter top={true} count={totalPurchaseNumber} />
        )}
      </a>
    );
  }
}

export default createRefetchContainer(
  CartBadge,
  {
    viewer: graphql`
      fragment CartBadge_viewer on Viewer {
        id
        cartBadge {
          approvalFlag
          totalPurchaseNumber
        }
      }
    `
  },
  graphql`
    query CartBadgeRefetchQuery {
      viewer {
        ...CartBadge_viewer
      }
    }
  `
);
